import { createFileRoute } from '@tanstack/react-router';
import { CalendarPage } from '@/features/scheduling/pages/calendar-page';

type Search = {
  date?: string;
  by?: 'member' | 'resource';
  view?: 'week' | 'month';
  staff?: string;
  book?: string;
  bookName?: string;
  appointment?: string;
};

export const Route = createFileRoute('/_app/calendar')({
  // ?date=YYYY-MM-DD opens the calendar on that day (links from the mini calendar on /today); ?view=week|month and
  // ?staff=<membership id> (the week / month staff filter) are written by the page as the user clicks, so a refresh or a
  // shared link comes back to the same screen (the page reads them once on open; back / forward is not synced);
  // ?appointment=<id> opens that appointment's drawer once (staff alerts), then the page drops it from the URL;
  // ?book=<customerId>&bookName=… opens the booking dialog for that customer (from the top-bar search)
  validateSearch: (s: Record<string, unknown>): Search => ({
    date: typeof s.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s.date) ? s.date : undefined,
    by: s.by === 'member' || s.by === 'resource' ? s.by : undefined,
    view: s.view === 'week' || s.view === 'month' ? s.view : undefined,
    staff: typeof s.staff === 'string' && s.staff.length > 0 ? s.staff : undefined,
    book: typeof s.book === 'string' && s.book.length > 0 ? s.book : undefined,
    bookName: typeof s.bookName === 'string' && s.bookName.length > 0 ? s.bookName : undefined,
    appointment: typeof s.appointment === 'string' && s.appointment.length > 0 ? s.appointment : undefined,
  }),
  component: CalendarPage,
});
